import React from 'react';
import UserAvatar from './userAvatar';
import DumpDisclaimerMessage from './dumpDisclaimerMessage';
import DumpSplashScreenBtnGroup from './dumpSplashScreenBtnGroup';
import DumpPrivacyLink from './dumpPrivacyLink';
import { isMobileDevice, isMobile } from './util';

const DumpSplashScreen = (props) => {
    const { className, hilightColor, viewerLogo, sentAt, showSharedContentDescription, sharedContentDescription, headerHTML } = props;
    const { showSplashScreenPasswordDescription, splashScreenPasswordDescription } = props;
    const { validatorComponent, myPrivacySettingsComponent, customFooterComponent } = props;
    const { showAvartar, userAvartarClassName, userAvartar, userName } = props;
    const { showDisclaimerMessage, disclaimerMsg, privacyLinkUrl, privacyPolicyText, readMoreText, readLessText, isNoDisclaimer, updateSelectLink } = props;
    const { continueViewText, onContinueView, showPrivacySettingBtn, useHyperLink, privacySettingBtnText, onClickPrivacySetting, showRejectAllBtn, rejectAllBtnText, onClickRejectAll } = props;

    const renderContent = () => {
        const DisclaimerMessage = (<DumpDisclaimerMessage
            updateSelectLink={updateSelectLink}
            hilightColor={hilightColor}
            disclaimerMsg={disclaimerMsg}
            privacyLinkUrl={privacyLinkUrl}
            privacyPolicyText={privacyPolicyText}
            readMoreText={readMoreText}
            readLessText={readLessText} />);

        const SplashScreenBtnGroup = (<DumpSplashScreenBtnGroup
            continueViewText={continueViewText}
            validatorComponent={validatorComponent}
            showPrivacySettingBtn={showPrivacySettingBtn}
            hilightColor={hilightColor}
            privacySettingBtnText={privacySettingBtnText}
            useHyperLink={useHyperLink}
            onClickPrivacySetting={onClickPrivacySetting}
            onContinueView={onContinueView}
            rejectAllBtnText={rejectAllBtnText}
            showRejectAllBtn={showRejectAllBtn}
            onClickRejectAll={onClickRejectAll} />);

        return (<div>
            {showDisclaimerMessage && DisclaimerMessage}
            {SplashScreenBtnGroup}
        </div>);
    };

    return (
        <div className={`seismic-engagement-linkinfo ${className}`}>
            <div className="seismic-engagement-linkinfo-logo-wrapper" role="banner" aria-label="Header">
                {viewerLogo && <img className="logo-Img" src={viewerLogo} alt="logo" />}
            </div>
            <div className="seismic-engagement-linkinfo-header seismic-engagement-password-validator-main-form" role="main" aria-label="GDPR screen">
                {showAvartar && (
                    <div key="avatar" className="sender-avatar-wrapper">
                        <UserAvatar
                            className={userAvartarClassName}
                            userName={userName}
                            hilightColor={hilightColor}
                            userAvartar={userAvartar} />
                    </div>
                )}
                {isMobileDevice.any() && !isMobile() && <div key="senttime" className="sent-time">
                    {sentAt}
                </div>}
                <div key="headerinfo" role="heading" aria-level="3" className="header-info" dangerouslySetInnerHTML={{ __html: headerHTML }} />
                {showSharedContentDescription && sharedContentDescription}
                {showSplashScreenPasswordDescription && (
                    <div key="headerinfo2" className="header-info-big">
                        {splashScreenPasswordDescription}
                    </div>
                )}
                {renderContent()}
                {isNoDisclaimer &&
                    <div className="engagement-viewer-continue-view-container engagement-viewer-privacy-policy-links-container">
                        <DumpPrivacyLink
                            updateSelectLink={updateSelectLink}
                            privacyLinkUrl={privacyLinkUrl}
                            privacyPolicyText={privacyPolicyText} />
                    </div>}
            </div>
            {customFooterComponent}
            {myPrivacySettingsComponent}
        </div>
    );
};

export default DumpSplashScreen;

